import { render, staticRenderFns } from "./AnalyticsAcademicStreamsRadarChart.vue?vue&type=template&id=ef36a2b2&"
import script from "./AnalyticsAcademicStreamsRadarChart.vue?vue&type=script&lang=js&"
export * from "./AnalyticsAcademicStreamsRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports